import version from '../version'

export default function () {
  return {
    backTo: null,
    version,
    enableMobileAnimations: false
  }
}
